/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S9_Li1_DescInputs */

const tr_iade_iptal_s9_li1_desc = /** @type {(inputs: Iade_Iptal_S9_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`menüsünden tek tıkla. İptal, ödenen dönemin sonunda hüküm doğurur; kalan süre için iade yapılmaz (5. maddedeki 3 gün kuralı ve 3. maddedeki yıllık plan iadesi saklıdır).`)
};

const en_iade_iptal_s9_li1_desc = /** @type {(inputs: Iade_Iptal_S9_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`with a single click from this menu. The cancellation takes effect at the end of the paid period; no refund is made for the remaining time (the 3-day rule in clause 5 and the annual plan refund under clause 3 remain reserved).`)
};

const de_iade_iptal_s9_li1_desc = /** @type {(inputs: Iade_Iptal_S9_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mit einem Klick über dieses Menü. Die Kündigung wird zum Ende des bezahlten Zeitraums wirksam; für die verbleibende Zeit erfolgt keine Erstattung (die 3-Tage-Regel der Ziffer 5 und die Erstattung beim Jahresplan nach Ziffer 3 bleiben vorbehalten).`)
};

const ru_iade_iptal_s9_li1_desc = /** @type {(inputs: Iade_Iptal_S9_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`одним нажатием в этом меню. Отмена вступает в силу по окончании оплаченного периода; возврат за оставшийся срок не производится (правило 3 дней из пункта 5 и возврат по годовому плану согласно пункту 3 сохраняют силу).`)
};

/**
* | output |
* | --- |
* | "with a single click from this menu. The cancellation takes effect at the end of the paid period; no refund is made for the remaining time (the 3-day rule in ..." |
*
* @param {Iade_Iptal_S9_Li1_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s9_li1_desc = /** @type {((inputs?: Iade_Iptal_S9_Li1_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S9_Li1_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s9_li1_desc(inputs)
	if (locale === "de") return de_iade_iptal_s9_li1_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s9_li1_desc(inputs)
	return tr_iade_iptal_s9_li1_desc(inputs)
});